// Mapping from a practitioner's specialty (as free-typed via SpecialtyCombobox)
// to the list of Questiomed library categories that are typically relevant
// for their day-to-day practice. Used by the Templates page to surface a
// "Suggéré pour vous" block on first login (when the practitioner has yet
// to save/pin any personal questionnaire).
//
// Keys are matched case-insensitively and fuzzy — e.g. typing "Cardio" or
// "Cardiologie" both resolve to the cardiology bucket. Fallback list stays
// deliberately short so first-run onboarding remains focused.
export const SPECIALTY_TO_CATEGORIES = {
  "Médecin généraliste":       ["Cardiologie", "Endocrinologie", "Santé mentale", "Rhumatologie", "Pneumologie"],
  "Médecine générale":         ["Cardiologie", "Endocrinologie", "Santé mentale", "Rhumatologie", "Pneumologie"],
  "Cardiologue":               ["Cardiologie", "Urgences"],
  "Cardiologie":               ["Cardiologie", "Urgences"],
  "Endocrinologue":            ["Endocrinologie", "Nutrition"],
  "Endocrinologie":            ["Endocrinologie", "Nutrition"],
  "Psychiatre":                ["Santé mentale", "Addictologie"],
  "Psychiatrie":               ["Santé mentale", "Addictologie"],
  "Psychologue":               ["Santé mentale"],
  "Rhumatologue":              ["Rhumatologie", "Douleur"],
  "Rhumatologie":              ["Rhumatologie", "Douleur"],
  "Neurologue":                ["Neurologie", "Douleur", "Santé mentale"],
  "Neurologie":                ["Neurologie", "Douleur", "Santé mentale"],
  "Pédiatre":                  ["Pédiatrie"],
  "Pédiatrie":                 ["Pédiatrie"],
  "Gastro-entérologue et hépatologue": ["Gastro-entérologie", "Nutrition"],
  "Hépato-gastro-entérologie": ["Gastro-entérologie", "Nutrition"],
  "Gastro-entérologie":        ["Gastro-entérologie", "Nutrition"],
  "Pneumologue":               ["Pneumologie"],
  "Pneumologie":               ["Pneumologie"],
  "Chirurgien orthopédiste et traumatologue": ["Rhumatologie", "Douleur"],
  "Chirurgie orthopédique et traumatologique": ["Rhumatologie", "Douleur"],
  "Chirurgien urologue":       ["Urologie"],
  "Urologie":                  ["Urologie"],
  "Gynécologue-obstétricien":  ["Gynécologie"],
  "Gynécologie-obstétrique":   ["Gynécologie"],
  "Gynécologie médicale":      ["Gynécologie"],
  "Médecine du travail":       ["Santé au travail", "Santé mentale"],
  "Médecine et santé au travail": ["Santé au travail", "Santé mentale"],
  "Médecin urgentiste":        ["Urgences"],
  "Médecine d'urgence":        ["Urgences"],
  "Gériatre":                  ["Gériatrie", "Santé mentale"],
  "Gériatrie":                 ["Gériatrie", "Santé mentale"],
  "Oncologue médical":         ["Oncologie/Soins palliatifs"],
  "Oncologie médicale":        ["Oncologie/Soins palliatifs"],
};

export function suggestedCategoriesFor(specialty) {
  if (!specialty) return [];
  const raw = String(specialty).trim();
  if (!raw) return [];
  if (SPECIALTY_TO_CATEGORIES[raw]) return SPECIALTY_TO_CATEGORIES[raw];
  const norm = raw.toLowerCase();
  for (const [key, cats] of Object.entries(SPECIALTY_TO_CATEGORIES)) {
    const lk = key.toLowerCase();
    if (norm.includes(lk) || lk.includes(norm)) return cats;
  }
  return [];
}
